module.exports = "#define GLSLIFY 1\n#ifdef USE_COLOR\n\n\tdiffuseColor.rgb *= vColor;\n\n#endif"